import { Injectable } from '@angular/core';

@Injectable()
export class UserdataService {

    private loggedInUserdata = null;

    constructor(
    ) {
    }

    public getLoggedInUser() {
        return this.loggedInUserdata;
    }

    public setLoggedInUser(userData = null, saveToDB = true) {
        if (userData) {
            this.loggedInUserdata = userData;
            if (!userData.email) delete userData.email;
            if (!userData.username) delete userData.username;
            if(saveToDB) {
                DLS_IPCCallers.USER_LOGIN(userData);
            }
        }
        else this.loggedInUserdata = null;
    }

    public async getLastLoggedInUser() {

        let loggedInUser = await DLS_IPCCallers.CHECK_LOGGED_IN();

        // return undefined if there is no previously logged in user
        if(!loggedInUser || !loggedInUser.length){
            return;
        }

        // only one user can be logged in at a moment
        loggedInUser = loggedInUser[0];
        let user:any = await this.getUserByUID(loggedInUser.uid);
        
        if(user && user.length){
            // only one user can be there in DB for a given uid
            user = user[0];

            if(loggedInUser.metadata){
                user.metadata = Object.assign((user.metadata || {}), loggedInUser.metadata);
            }
        }
        
        return user;
    }

    getUserByUID(uid) {

        if (uid == null || uid.length == 0) {
            return [];
        }

        return DLS_IPCCallers.USER_CHECK(uid);

    }

}